<template>
  <div class="overlay__image-container--single">
    <picture class="picture--center">
      <img :alt="altText" :src="imageSrc" class="picture__img--scale--focusable" draggable="false"
        data-prevent-context-menu data-overlay-image data-overlay-prevent-close data-toggle-controls
        data-gtm="overlay / clicks hero image" tabindex="1" onerror="window.MoMA.onImageError(this, 1)" loading="lazy"
        ref="overlayImage" />
    </picture>
  </div>
</template>

<script>
import CarouselNav from "../collection/carousel/carousel-nav.vue";

export default {
  components: { CarouselNav },
  props: {
    altText: { type: String, required: true },
    imageSrc: { type: String, required: true },
    title: { type: String, required: false, default: '' }
  },
}
</script>
